<template>
  <div class="chat_ai">
    <div v-if="!item.content[item.content.length-1].isCompletedAIChat">
      <AILoading></AILoading>
    </div>
    <div v-else>
      <VMarkdownView
          :mode="mode"
          :content="item.content[item.content.length-1].content"
      >
      </VMarkdownView>
      <transition name="fade">
        <div v-if="item.content[item.content.length-1].isCompletedAIChat" class="tools-bar">
          <div style="display: flex;align-items: center">
            <el-button type="info" class="btn-tool" round>
              {{ $t('ai.com.txt')}}
            </el-button>
            <el-icon style="margin-left: 10px">
              <CopyDocument/>
            </el-icon>
            <el-icon style="margin-left: 10px">
              <Refresh/>
            </el-icon>
          </div>
          <div>
            <PageCom></PageCom>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup>
import {ref, watch} from "vue";
import {VMarkdownView} from 'vue3-markdown'
import 'vue3-markdown/dist/style.css'
import AILoading from "@/components/AI/AILoading.vue";
import PageCom from "@/components/AI/Page.vue"

const mode = ref('light')
const {item} = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<style lang="less" scoped>
.chat_ai {
  margin-top: 10px;
  max-width: 350px;
  width: auto;
  border-radius: 6px;
  height: auto;
  background: #EFEFEF;
  padding: 10px 20px 10px 20px;
  font-size: 14px !important;
  margin-right: auto;
}

:deep(.markdown-body) {
  background: #EFEFEF !important;
  font-size: 14px !important;
}

.btn-tool {
  width: 100px;
  height: 30px;
  background: #FFFFFF;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  color: black;
  border: 0px transparent;
}

.tools-bar {
  height: 30px;
  width: 100%;
  background: red;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>